import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { MdOutlineWarning } from "react-icons/md";

import config from '../../config/config';
import constant from '../../utils/Constant';

const {
    DASHBOARD_END_POINT,
    BOOLEAN_TRUE: trueValue,
    BOOLEAN_FALSE: falseValue,
    STATUS_200,
    STATUS_401,
    LOGOUT,
    VENDOR_DETAILS_END_POINT,
    NULL,
    ONE
} = constant;

function Dashboard() {
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [vendorStatus, setVendorStatus] = useState(NULL);
    const [isTrue, setIsTrue] = useState(falseValue);

    // * get token from local storage
    const token = localStorage.getItem('vendor_dashboard');

    // * execute dashboard api
    const executeDashboardApi = useCallback(async () => {
        try {
            const apiUrl = config.appBaseUrl + DASHBOARD_END_POINT;

            // * execute get request
            const response = await axios.get(apiUrl, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // * api response
            const result = response.data;

            // * if response is success
            if (result.code === STATUS_200 && result.status) {
                setData(result.data);
            }
        } catch (error) {
            toast.error(error.response?.data?.message);
            // * if token is expired
            if (error.response?.data?.code === STATUS_401) {
                navigate(LOGOUT);
            }
        }
    }, [navigate, token]);

    // * execute vendor detaits api
    useEffect(() => {
        executeDashboardApi();
    }, [executeDashboardApi, token]);

    // * execute vendor detaits api
    const executeAllVendorApi = useCallback(async () => {
        try {
            const apiUrl = config.appBaseUrl + VENDOR_DETAILS_END_POINT;

            // * execute get request
            const response = await axios.get(apiUrl, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // * api response
            const result = response.data;

            // * if response is success
            if (result.code === STATUS_200 && result.status) {
                localStorage.setItem('vendor_dashboard_status', result.data.status);
                setVendorStatus(result.data.status);
                setIsTrue(trueValue);

                //* dispatch event after updating localStorage
                window.dispatchEvent(new Event('vendorStatusUpdated'));
            }
        } catch (error) {
            // * if token is expired

            console.log(error)
            if (error.response?.data?.code === STATUS_401) {
                navigate(LOGOUT);
            }
            toast.error(error);
        }
    }, [navigate, token]);

    // * execute vendor detaits api
    useEffect(() => {
        executeAllVendorApi();
    }, [executeAllVendorApi, token]);

    return (
        <>
            <ToastContainer autoClose={700} position='top-center' />

            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <h4 className="mb-0">Dashboard</h4>
                            </div>
                        </div>
                    </div>
                    {
                        (isTrue && vendorStatus !== ONE) && (
                            <div
                                className={`alert d-flex align-items-center justify-content-start border-property p-1 mb-4  alert-warning`}
                                role="alert"
                            >
                                <div className="mx-2">
                                    <MdOutlineWarning size={25} style={{ marginBottom: '2px' }} />
                                </div>
                                <h2 className='pt-2'>
                                    Your account is under review
                                </h2>
                            </div>
                        )
                    }
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="row">
                                <div className="col-xl-4 col-md-4">
                                    <div className="card">
                                        <div className="card-body p-0">
                                            <div className="p-4">
                                                <div className="d-flex">
                                                    <div className="flex-1">
                                                        <h3 className="mb-3">
                                                            <span className="counter_value" data-target={19}>
                                                                {data.new}
                                                            </span>
                                                        </h3>
                                                    </div>
                                                    <div className="">
                                                        <p className="badge badge-golden-lighten font-size-12 mb-0">
                                                            Yearly
                                                        </p>
                                                    </div>
                                                </div>
                                                <h5 className="text-muted font-size-14 mb-0">Total New Quotation</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-md-4">
                                    <div className="card">
                                        <div className="card-body p-0">
                                            <div className="p-4">
                                                <div className="d-flex">
                                                    <div className="flex-1">
                                                        <h3 className="mb-3">
                                                            <span className="counter_value" data-target={0}>
                                                                {data.replied}
                                                            </span>
                                                        </h3>
                                                    </div>
                                                    <div className="">
                                                        <p className="badge badge-golden-lighten font-size-12">
                                                            Yearly
                                                        </p>
                                                    </div>
                                                </div>
                                                <h5 className="text-muted font-size-14 mb-0">
                                                    Total Replied Quotation
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-md-4">
                                    <div className="card">
                                        <div className="card-body p-0">
                                            <div className="p-4">
                                                <div className="d-flex">
                                                    <div className="flex-1">
                                                        <h3 className="mb-3">
                                                            <span className="counter_value" data-target={4}>
                                                                {data.closed}
                                                            </span>
                                                        </h3>
                                                    </div>
                                                    <div className="">
                                                        <p className="badge badge-golden-lighten font-size-12">
                                                            Yearly
                                                        </p>
                                                    </div>
                                                </div>
                                                <h5 className="text-muted font-size-14 mb-0">
                                                    Total Close Quotation
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Dashboard;